import { createAction, props } from "@ngrx/store";

export const setResumeUpload = createAction(
  'Set Resume Upload',
  props<{ resume_upload: boolean }>(),
)